window.BTF = window.BTF || {};

if ( ! window.BTF.HighVariantPicker ) {
	window.BTF.HighVariantPicker = () => {
		document.addEventListener( 'change', e => {
			const input = e.target;
			if ( input.type !== 'radio' ) {
				return;
			}

			const optionValueSelectors = input.closest( '.optionValueSelectors' );
			if ( ! optionValueSelectors ) {
				return;
			}

			const sectionId  = optionValueSelectors.dataset.sectionId;
			const productEl  = input.closest( '[data-product-url][data-section-id]' );
			const productUrl = productEl?.dataset.productUrl || window.location.pathname;

			const selectedOptionValues = Array.from(
				optionValueSelectors.querySelectorAll( 'input[type="radio"]:checked' )
			).map( el => el.dataset.optionValueId );

			const params = selectedOptionValues.length
				? `&option_values=${ selectedOptionValues.join( ',' ) }`
				: '';

			// /products/slug?section_id=...&option_values=1,2,3
			fetch( `${ productUrl }?section_id=${ sectionId }${ params }`, {
				headers: { 'X-Requested-With': 'XMLHttpRequest' }
			} )
				.then( res => res.text() )
				.then( htmlString => {
					const doc = new DOMParser().parseFromString( htmlString, 'text/html' );

					const newSelectors = doc.querySelector( '.optionValueSelectors' );
					if ( newSelectors ) {
						optionValueSelectors.innerHTML = newSelectors.innerHTML;
					}

					const newVariantInput     = doc.querySelector( '[data-variant-input]' );
					const currentVariantInput = productEl?.querySelector( '[data-variant-input]' );

					if ( newVariantInput && currentVariantInput ) {
						currentVariantInput.value = newVariantInput.value;
					}

					const newVariantData = doc.querySelector('[data-selected-variant]');
					let selectedVariant = null;

					if (newVariantData) {
						try {
							selectedVariant = JSON.parse(newVariantData.textContent);
						} catch (e) {
							console.error('[HighVariantPicker] JSON parse error', e);
						}
					}

					if ( productEl ) {
						let gallery  = productEl.querySelector( '.main-product' ),
							featured = productEl.querySelector( '.featured-product-product' ),
							image    = featured ? featured.querySelector( '.media-preview' ) : false,
							summary  = productEl.querySelector( '.product-summary' );

						let price     = summary.querySelector( '.product-price' ),
							form      = summary.querySelector( '[data-type="add-to-cart-form"]' ),
							productId = form ? form.querySelector( '[name="id"]' ) : false,
							button    = form ? form.querySelector( '[name="add"]' ) : false,
							pickup    = summary.querySelector( '.pickup-availability' ),
							amount    = summary.querySelector( '.product-sale-label .sale-total .saved-number' );

						let indexSlide = 0;

						if ( selectedVariant ) {
							// Update product variant ID.
							if ( productId ) {
								productId.value = selectedVariant.id;
							}

							// Update image on Featured product.
							if ( image && selectedVariant.featured_image ) {
								image.removeAttribute( 'srcset' );
								btyImageLoad( image, selectedVariant.featured_image.src, selectedVariant.featured_media.id, image.parentNode );
							}

							// Update product url.
							if ( productUrl ) {
								window.history.replaceState( {}, '', productUrl + '?variant=' + selectedVariant.id );
							}

							// Update price.
							if ( price ) {
								price.innerHTML = btyPriceHtml( selectedVariant.price, selectedVariant.compare_at_price, selectedVariant.unit_price, selectedVariant.unit_price_measurement );
							}

							// Update saved price badge.
							if ( amount ) {
								if ( selectedVariant.compare_at_price ) {
									let amountTotal = 100 * ( selectedVariant.compare_at_price - selectedVariant.price ) / selectedVariant.compare_at_price;

									amount.innerHTML = amountTotal.toFixed( 2 );

									amount.closest( '.summary-item' ).classList.remove( 'hidden' );
								} else {
									amount.closest( '.summary-item' ).classList.add( 'hidden' );
								}
							}

							// Check group image.
							let groupImage = document.querySelectorAll( '.check-group-image .group-image[data-color]' );
							if ( groupImage.length ) {
								let colorName = ( selectedVariant.featured_media && selectedVariant.featured_media.alt ) ? selectedVariant.featured_media.alt.split( '_' )[0] : false;
								if ( colorName ) {
									groupImage.forEach(
										function ( gi ) {
											let label = gi.getAttribute( 'data-color' ).trim();
											if ( ! label ) {
												return;
											}

											if ( colorName == label ) {
												gi.parentNode.classList.remove( 'sr-only' );
											} else {
												gi.parentNode.classList.add( 'sr-only' );
											}
										}
									);
								}
							} else {
								// Scroll to current variant media.
								let headerSticky = document.querySelector( '.header.is-sticky' ),
									headerHeight = headerSticky ? headerSticky.offsetHeight : 0,
									currentMedia = gallery && selectedVariant.featured_media ? gallery.querySelector( '.media-preview-wrap[data-id="' + selectedVariant.featured_media.id + '"]' ) : false;
								if ( currentMedia ) {
									window.scrollTo(
										{
											top: ( currentMedia.getBoundingClientRect().top + window.pageYOffset - headerHeight ),
											behavior: 'smooth'
										}
									);

									indexSlide = Number( currentMedia.getAttribute( 'data-pos' ) ) - 1;
								}
							}
						}

						// Update shop pay installments.
						let shopifyPayment = document.querySelector( 'shopify-payment-terms' );
						if ( shopifyPayment ) {
							shopifyPayment.setAttribute( 'variant-id', selectedVariant.id );
						}

						// Pickup availability, sold out products should not show the pickup availability.
						if ( pickup ) {
							if ( selectedVariant && selectedVariant.available ) {
								btyPickupAvailability( doc, productId.value, pickup );
							} else {
								pickup.innerHTML = '';
							}
						}

						// Update form state.
						if ( form ) {
							if ( selectedVariant && selectedVariant.available ) {
								form.classList.remove( 'disabled' );
							} else {
								form.classList.add( 'disabled' );
							}
						}

						// Update add to cart button text.
						if ( button ) {
							if ( selectedVariant ) {
								if ( selectedVariant.available ) {
									button.innerHTML = btyStrings.product.add_to_cart;
									button.classList.remove( 'disabled' );
								} else {
									button.innerHTML = btyStrings.product.out_of_stock;
									button.classList.add( 'disabled' );
								}
							} else {
								button.classList.add( 'disabled' );
								button.innerHTML = btyStrings.product.unavailable;
							}
						}

						// Add custo event.
						const customData = {
							detail: {
								indexSlide: indexSlide,
								selected: selectedVariant
							}
						}

						const customEvent = new CustomEvent( 'product-variant-updated', customData );

						document.documentElement.dispatchEvent( customEvent );
					}

					document.getElementById( input.id )?.focus();
				} )
				.catch( err => {
					console.error( '[HighVariantPicker] fetch error', err );
				} );
		} );
	};

	window.BTF.HighVariantPicker();
}